<template>
	<div>
		<Dialog :header="$t('Report')" :visible.sync="displayTeamReport" :style="{width: '95%', height: '100%'}" :contentStyle="{height: '100%'}">
			<TeamReport :team-id="selectedTeamId" />
		</Dialog>

		<Dialog :header="$t('WhatsappTitle')" :visible.sync="displaySendWhatsapp" :style="{width: '50%', height: '65%'}" :contentStyle="{height: '100%'}">
			<div class="p-grid">
				<div class="p-col-12">
					<img :src="commonService.getCDNImageUrl(whatsappData.TeamAvatar)" @error="commonService.defaultTeamAvatarUrl" width="50" height="50" style="vertical-align: middle; border-radius: 50%;" />
					<span style="padding-left: 0.5em; cursor: pointer">{{whatsappData.TeamName}}</span>
					<p>
						<strong>{{$t('name')}}: </strong>
						<InputText v-model="whatsappData.TeamContactName" />
					</p>
					<p>
						<strong>{{$t('phone')}}: </strong>
						<InputText v-model="whatsappData.TeamContactPhone" />
					</p>
				</div>
			</div>

			<Textarea v-model="whatsappMessage" style="width: 100%; height: 200px; margin-top: 0.5em; margin-bottom: 0.5em" />
			<Button :label="$t('Send')" @click="sendWhatsappToTeam()" />
		</Dialog>

		<div class="p-grid">
			<div class="p-col-12">
				<Toast />
				<div class="card card-w-title">
					<h1>{{$t('CoachingStaffList')}}</h1>
					<DataTable :value="teams" :paginator="true" class="p-datatable-customers" showGridlines :rows="15" dataKey="Id" :filters.sync="filters" filterDisplay="row" :loading="loading" responsiveLayout="scroll" :globalFilterFields="['Name', 'CountryRegion', 'ProfileName', 'CategoryName', 'OrgChartItemName', 'TeamName']" @row-select="showTeamReport" :rowsPerPageOptions="[15,30,60]" :rowHover="true" selectionMode="single">
						<template #header>
							<div class="flex justify-content-end">
								<span class="p-input-icon-left ">
									<i class="pi pi-search" />
									<InputText v-model="filters['global'].value" :placeholder="$t('GlobalSearch')" />
								</span>
							</div>
						</template>
						<template #empty>
							{{$t('NoCoachingStaffsFound')}}
						</template>
						<template #loading>
							{{$t('LoadingCoachingStaffs')}}
						</template>
						<Column field="Name" :header="$t('name')" :sortable="true">
							<template #body="{data}">
								<span class="p-column-title">{{$t('name')}}</span>
								<span style="padding-left: 0.5em">{{data.Name}}</span>
							</template>
							<template #filter="{filterModel}">
								<InputText type="text" v-model="filterModel.value" class="p-column-filter" :placeholder="$t('SearchByName')" />
							</template>
						</Column>
						<Column field="OrgChartItemName" :header="$t('Role')" :sortable="true">
							<template #body="{data}">
								<span class="p-column-title">{{$t('Role')}}</span>
								<span>{{data.OrgChartItemName}}</span>
							</template>
							<template #filter="{filterModel}">
								<InputText type="text" v-model="filterModel.value" class="p-column-filter" :placeholder="$t('SearchByDefaultOrgChartItem')" />
							</template>
						</Column>
						<Column field="TeamName" :header="$t('TeamName')" :sortable="true">
							<template #body="{data}">
								<span class="p-column-title">{{$t('TeamName')}}</span>
								<img :src="commonService.getCDNImageUrl(data.TeamUserImageUrl)" @error="commonService.defaultTeamAvatarUrl" width="32" height="32" style="vertical-align: middle; border-radius: 50%;" />
								<span style="padding-left: 0.5em">{{data.TeamName}}</span>
							</template>
							<template #filter="{filterModel}">
								<InputText type="text" v-model="filterModel.value" class="p-column-filter" :placeholder="$t('SearchByTeamName')" />
							</template>
						</Column>
						<Column field="CategoryName" :header="$t('TeamCategory')" :sortable="true">
							<template #body="{data}">
								<span class="p-column-title">{{$t('TeamCategory')}}</span>
								<span>{{data.CategoryName}}</span>
							</template>
							<template #filter="{filterModel}">
								<InputText type="text" v-model="filterModel.value" class="p-column-filter" :placeholder="$t('SearchByTeamCategory')" />
							</template>
						</Column>
						<Column field="CountryRegion" :header="$t('Country/Region')" :sortable="true">
							<template #body="{data}">
								<span class="p-column-title">{{$t('Country/Region')}}</span>
								<CountryFlag v-if="data.Country" :country="data.Country" />
								<span v-if="data.Region" style="vertical-align: middle"> / {{$t(data.Region)}}</span>
							</template>
							<template #filter="{filterModel}">
								<InputText type="text" v-model="filterModel.value" class="p-column-filter" :placeholder="$t('SearchByCountryRegion')" />
							</template>
						</Column>
						<Column field="ProfileName" :header="$t('Profile')" :sortable="true">
							<template #body="{data}">
								<span class="p-column-title">{{$t('Profile')}}</span>
								<span v-if="data.ProfileName == $t('Registered')" :class="'profile-badge profile-registered'">{{$t('Registered')}}</span>
								<span v-else-if="data.ProfileName == $t('Not Registered')" :class="'profile-badge profile-notregistered'">{{$t('Not Registered')}}</span>
								<span v-else-if="data.ProfileName == $t('Not Accepted')" :class="'profile-badge profile-notaccepted'">{{$t('Not Accepted')}}</span>
							</template>
							<template #filter="{filterModel}">
								<InputText type="text" v-model="filterModel.value" class="p-column-filter" :placeholder="$t('SearchByProfile')" />
							</template>
						</Column>
						<Column v-if="authService.getUserRole() == $agentTirolibre" field="LastUpdate" :header="$t('LastUpdate')" :sortable="true">
							<template #body="{data}">
								<span class="p-column-title">{{$t('LastUpdate')}}</span>
								{{data.LastUpdate}}
							</template>
							<template #filter="{filterModel}">
								<InputText type="text" v-model="filterModel.value" class="p-column-filter" :placeholder="$t('SearchByLastUpdate')" />
							</template>
						</Column>
						<Column :styles="{'min-width':'12rem'}">
							<template #body="{data}">
								<Button v-if="authService.getUserRole() == $agentTirolibre" type="button" icon="pi pi-comment" class="p-button-info" style="margin-right: .25em" @click="showSendWhatsapp(data)"></Button>
							</template>
						</Column>
					</DataTable>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TeamService from "@/service/TeamService";
import TeamReport from "@/components/team/TeamReport";
import CountryFlag from "@/components/CountryFlag";
import OrgChartRoleDropdown from "@/components/dropdown/OrgChartRoleDropdown";
import EnumService from "@/service/EnumService";
import AuthService from "@/service/AuthService";
import CommonService from "@/service/CommonService";
import WhatsappService from "@/service/WhatsappService";
import { FilterMatchMode } from "primevue/api/";

export default {
	components: {
		TeamReport,
		OrgChartRoleDropdown,
		CountryFlag,
	},
	data: function () {
		return {
			teams: [],
			displayTeamReport: false,
			selectedTeam: null,
			selectedProfile: null,
			loading: true,
			filters: {
				global: { value: null, matchMode: FilterMatchMode.CONTAINS },
				Name: {
					value: null,
					matchMode: FilterMatchMode.STARTS_WITH,
				},
				CountryRegion: {
					value: null,
					matchMode: FilterMatchMode.STARTS_WITH,
				},
				ProfileName: {
					value: null,
					matchMode: FilterMatchMode.STARTS_WITH,
				},
				TeamName: {
					value: null,
					matchMode: FilterMatchMode.STARTS_WITH,
				},
				CategoryName: {
					value: null,
					matchMode: FilterMatchMode.STARTS_WITH,
				},
				OrgChartItemName: {
					value: null,
					matchMode: FilterMatchMode.STARTS_WITH,
				},
			},
			displaySendWhatsapp: false,
			whatsappData: {},
			displayDeleteConfirmation: false,
			teamIdToDelete: null,
			selectedOrgChatItem: null,
			selectedTeamId: null,
		};
	},
	teamService: null,
	enumService: null,
	authService: null,
	commonService: null,
	whatsappService: null,
    whatsappMessage: null,
	created() {
		this.teamService = new TeamService();
		this.enumService = new EnumService();
		this.authService = new AuthService();
		this.commonService = new CommonService();
		this.whatsappService = new WhatsappService();

		this.loadTeamContacts();
	},
	methods: {
		loadTeamContacts() {
			let self = this;
			this.teamService.getTeamOrgChartContacts().then(
				(res) => {
					res.data.forEach(function (obj) {
						self.formatTeamContactsToList(obj);
					});
					this.teams = res.data;
					this.loading = false;
				},
				function (err) {
					self.$toast.add({
						severity: "error",
						summary: self.$t("errorMessage"),
						detail: self.$t("Error"),
						life: 3000,
					});
				}
			);
		},
		formatTeamContactsToList(obj) {
			obj.CountryRegion = obj.Country + "/" + this.$t(obj.Region);
			obj.ProfileName = this.enumService.getEnumName(
				this.enumService.getTeamProfileEnum(),
				obj.Profile
			);
			obj.CategoryName = this.enumService.getEnumName(
				this.enumService.getCategoryEnum(),
				obj.Category
			);
			obj.OrgChartItemName = this.enumService.getEnumName(
				this.enumService.getOrgChartRoleEnum(),
				obj.Role
			);
			if (obj.LastUpdate) obj.LastUpdate = obj.LastUpdate.split("T")[0];

			return obj;
		},
		showTeamReport(teamContact) {
			this.selectedTeamId = teamContact.data.TeamBaseUserId;
			this.displayTeamReport = true;
		},
		showSendWhatsapp(teamContact) {
			this.whatsappData = {
				TeamContactPhone: teamContact.Phone,
				TeamName: teamContact.TeamName,
				TeamAvatar: teamContact.TeamUserImageUrl,
				TeamContactName: teamContact.Name,
				TeamId: teamContact.TeamBaseUserId,
			};

			this.displaySendWhatsapp = true;
		},
		sendWhatsappToTeam() {
			let self = this;

			this.whatsappService
				.sendTextWhatsappToTeam(
					this.whatsappData.TeamContactPhone,
					this.whatsappMessage,
					this.whatsappData.TeamId,
					this.whatsappData.TeamContactName
				)
				.then(
					(res) => {
						self.$toast.add({
							severity: "success",
							summary: self.$t("okMessage"),
							detail: self.$t("WhatsappSent"),
							life: 3000,
						});

						this.displaySendWhatsapp = false;
					},
					function (err) {
						self.$toast.add({
							severity: "error",
							summary: self.$t("errorMessage"),
							detail: self.$t("Error"),
							life: 3000,
						});

						this.displaySendWhatsapp = false;
					}
				);
		},
	},
};
</script>

<style lang="scss" scoped>
.profile-badge {
	border-radius: 2px;
	padding: 0.25em 0.5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: 0.3px;
	&.profile-registered {
		background-color: #c8e6c9;
		color: #256029;
	}
	&.profile-notaccepted {
		background-color: #ffcdd2;
		color: #c63737;
	}
	&.profile-notregistered {
		background-color: #b3e5fc;
		color: #23547b;
	}
}
</style>